import {
  FieldAdornmentOption,
  type FieldMap,
} from '@snap-types/models/auto-configurator/state';

import { buildQuantityBreakField } from '../builders/quantity-break';
import {
  requiredWhenLineItemValuePresentForQuantityBreak,
  validateQuantityGreaterThanOrEqualToMinimumQuantity,
  validateQuantityGreaterThanPreviousQuantityBreak,
  validateQuantityLessThanNextQuantityBreak,
} from '../validation/custom-validator-helpers';

export function createQuantityBreakFields(): FieldMap['quantityBreak'] {
  return {
    quantity: buildQuantityBreakField('quantity', {
      type: 'decimal',
      isReadonly: false,
      isRequired: true,
      validation: {
        min: 1,
      },
      validators: [
        validateQuantityGreaterThanPreviousQuantityBreak(),
        validateQuantityLessThanNextQuantityBreak(),
        validateQuantityGreaterThanOrEqualToMinimumQuantity(),
      ],
    }),

    sems1Cost: buildQuantityBreakField('sems1Cost', {
      type: 'decimal',
      leftAdornment: FieldAdornmentOption.dollarSign,
      isReadonly: false,
      validation: {
        min: 0,
      },
      validators: [
        requiredWhenLineItemValuePresentForQuantityBreak('sems1Style'),
      ],
    }),

    sems2Cost: buildQuantityBreakField('sems2Cost', {
      type: 'decimal',
      leftAdornment: FieldAdornmentOption.dollarSign,
      isReadonly: false,
      validation: {
        min: 0,
      },
      validators: [
        requiredWhenLineItemValuePresentForQuantityBreak('sems2Style'),
      ],
    }),

    osp2Price: buildQuantityBreakField('osp2Price', {
      type: 'decimal',
      leftAdornment: FieldAdornmentOption.dollarSign,
      isReadonly: false,
    }),

    osp3Price: buildQuantityBreakField('osp3Price', {
      type: 'decimal',
      leftAdornment: FieldAdornmentOption.dollarSign,
      isReadonly: false,
    }),

    userGrossMargin: buildQuantityBreakField('userGrossMargin', {
      type: 'decimal',
      isReadonly: false,
      validation: {
        max: 0.9999,
      },
    }),

    grossMarginIsOverridden: buildQuantityBreakField(
      'grossMarginIsOverridden',
      { type: 'boolean', isReadonly: false },
    ),

    userUnitPrice: buildQuantityBreakField('userUnitPrice', {
      type: 'decimal',
      leftAdornment: FieldAdornmentOption.dollarSign,
      isReadonly: false,
      validation: {
        min: 0.0001,
      },
    }),

    unitPriceIsOverridden: buildQuantityBreakField('unitPriceIsOverridden', {
      type: 'boolean',
      isReadonly: false,
    }),

    userLeadTimeWeeks: buildQuantityBreakField('userLeadTimeWeeks', {
      type: 'number',
      isReadonly: false,
      validation: {
        min: 0,
      },
    }),

    leadTimeWeeksIsOverridden: buildQuantityBreakField(
      'leadTimeWeeksIsOverridden',
      { type: 'boolean', isReadonly: false },
    ),
  };
}

export const quantityBreakFields = createQuantityBreakFields();
